import { createFileRoute } from "@tanstack/react-router";
import TermsOfServiceView from "@/components/views/TermsOfService/terms-of-service.view";

export const Route = createFileRoute("/terms-of-service")({
    component: RouteComponent,
});

function RouteComponent() {
    return <TermsOfServiceView />;
}
